window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};

repos.casinoSprintRepo = function () {

    var url = 'api/casinosprint';

    var rezultati = function (promotion) {
        return fetch(url + '?promocija=' + promotion, {
            credentials: repos.base.credentials
        })
            .then(casino.repos.base.checkResponse)
            .then(function (response) {
                return response.json();
            })
            .catch(casino.repos.base.handleNetworkException);
    };

    return {
        rezultati: rezultati
    }

}();